/**
 * Checks an AbortSignal and, if it has been aborted, throws an AbortError
 *
 * @param signal - The AbortSignal to check
 */
export function checkSignal(signal: AbortSignal | null | undefined): void {
    if (signal?.aborted) throw new DOMException("AbortSignal was aborted", "AbortError");
}
